module.exports = __webpack_public_path__ + "static/media/Apple Chancery-01.673bbfe3.svg";